import { addFormDataEventListener } from '../modules/contactForm';

const STORAGE_KEY = 'waypointHistory';

function getCanonicalUrl(): string | null {
  const link = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
  return link?.href || null;
}

function getWaypointType(): string {
  const body = document.body;
  return body?.getAttribute('data-waypoint-type');
}

function saveWaypointHistoryEntry() {
  const url = getCanonicalUrl();
  if (!url) return;

  const type = getWaypointType();
  if (!type) return;

  const now = Math.round(Date.now() / 1000);
  const title = document.title;

  let history = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]') as Array<{ url: string; time: number; type: string; title: string }>;
  if (!Array.isArray(history)) {
    history = [];
  }

  // Prevent consecutive duplicate URLs
  if (history.length > 0 && history[history.length - 1].url === url) {
    return;
  }

  history.push({ url, time: now, type, title });

  localStorage.setItem(STORAGE_KEY, JSON.stringify(history));
}

window.addEventListener('DOMContentLoaded', saveWaypointHistoryEntry);

addFormDataEventListener((evt: FormDataEvent) => {
  const history = localStorage.getItem(STORAGE_KEY);
  if (evt.formData.has('waypointHistory') || !history) {
    return;
  }
  evt.formData.append('waypointHistory', history);
});
